import '../styles/tailwind.css';

import '../styles/admin/accordeon.css';
import '../styles/admin/breadcrumb.css';
import '../styles/admin/button.css';
import '../styles/admin/dialog.css';
import '../styles/admin/flash.css';
import '../styles/admin/form.css';
import '../styles/admin/list.css';
import '../styles/admin/panel.css';

import './polyfills/polyfill';

import './admin/tabs';
import './admin/dropdown.js';
import './admin/drawer.js';
import './address/api';
import './kvk/autocomplete';
import './admin/ajax-modal';
import './admin/components/color-field';
import './admin/collaborate-intermediary-lease-request';
import './admin/crm';
import './admin/crm/commission-rule-calculator';
import './admin/crm/customer-search';
import './admin/dark-mode';
import './admin/dialog';
import './admin/sidebar';
import './admin/stock/vehicle-search';
import './admin/symfony-collection';
import './admin/global-search';
import './admin/notification-registration';
import './admin/push-autowise-app';
import './admin/flash-message';
import './admin/simple-search';
import './admin/avatar-preview';

import { openDetailsElementFromNavigation } from './admin/util/detailModalElementOpenerUtil';

openDetailsElementFromNavigation(window);
